import { render, staticRenderFns } from "./create-questions-catalogue-form.vue?vue&type=template&id=5f42710d&scoped=true&"
import script from "./create-questions-catalogue-form.vue?vue&type=script&lang=ts&"
export * from "./create-questions-catalogue-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f42710d",
  null
  
)

export default component.exports